export const ENABLE_AMENDMENT_AI_SLIDE_OUT = 'enable-amendment-ai-slide-out';
export const ENABLE_AMENDMENT_V2_JOURNEY = 'enable-llc-amendment-v2-journey';
export const ENABLE_ANNUAL_REPORT_V2_JOURNEY = 'enable-llc-annual-report-v-2-journey';
export const ENABLE_BLF_PRODUCT = 'enable-blf-product';
export const ENABLE_BLR_SPECIFIC_CONTENT = 'enable-blr-specific-content';
export const ENABLE_BNPL_R2_FAILED_PAYMENT_RECOVERY = 'enable-bnpl-r2-failed-payment-recovery';
export const BNPL_R2_FAILED_PAYMENT_RECOVERY_EXPERIMENT_NAME = 'bnpl_r2_failed_payment_recovery';
export const ENABLE_DASHBOARD_LINK_TO_MANAGE_COOKIES = 'enable-dashboard-link-to-manage-cookies';
export const ENABLE_DASHBOARD_SUBSCRIPTION_DNR = 'enable-dashboard-subscription-dnr';
export const ENABLE_DASHBOARD_SUBSCRIPTION_RESTART = 'enable-dashboard-subscription-restart';
export const ENABLE_EIN_V3_JOURNEY = 'enable-ein-v-3-journey';
export const ENABLE_FUNDBOX_QUALIFIED_LIST_CONTROL = 'enable-fundbox-qualified-list-control';
export const ENABLE_HOLIDAY_BANNER = 'enable-holiday-banner';
export const ENABLE_INVOICE_PAYMENT_PAGE = 'enable-invoice-payment-page';
export const ENABLE_M2A = 'enable-m2a';
export const ENABLE_ORDER_TRACKER_RA_IR = 'enable-order-tracker-ra-ir';
export const ENABLE_UJM_DNR_PREM_PLAN = 'enable-osm-dnr-prem-plan';
export const ENABLE_UJM_DNR_PRO_PLAN = 'enable-osm-dnr-pro-plan';
export const ENABLE_UJM_DNR_WFC = 'enable-osm-dnr-wfc';
export const ENABLE_UJM_DNR_ZB_MONEY_PRO = 'enable-ujm-dnr-zb-money-pro';
export const ENABLE_UJM_RA_STANDALONE_DNR = 'enable-ujm-ra-standalone-dnr';
export const ENABLE_ENTERPRISE_DASHBOARD = 'enable-partner-dashboard';
export const ENABLE_PRODUCT_LANDING_PERSONALIZATION = 'enable-product-landing-personalization';
export const ENABLE_SCORP_BUNDLE_V1 = 'enable-s-corp-bundle-v-1';
export const ENABLE_VELO_ASSISTANT = 'enable-velo-assistant';
export const RELEASE_APRIL_TAX_SERVICES = 'release-april-tax-services';
export const RELEASE_APRIL_TAX_SERVICES_PHASE_2 = 'release-april-tax-services-phase-2';
export const RELEASE_BUSINESS_PROFILE_V2 = 'release-business-profile-v2';
export const RELEASE_COMPANIES_PAGE = 'release-companies-page';
export const RELEASE_CONSTANT_CONTACT_PRODUCT_CARD = 'release-constant-contact-product-card';
export const RELEASE_FINANCE_HUB = 'release-finance-hub';
export const RELEASE_SQUARESPACE_DOMAINS_RESELLER = 'release-squarespace-domains-reseller';
export const RELEASE_VELO_ORDER_STATUS = 'release-velo-order-status';
export const SHOW_DOWNLOAD_RECEIPTS = 'show-download-receipts';
export const SHOW_ORPHAN_ACCOUNT_OPTIONS = 'show-orphan-account-options';
export const VELO_REPLACE_NEXT_UP_CARDS = 'velo-replace-next-up-cards';
export const WHILE_YOU_WAIT_WIDGET = 'while-you-wait-widget';
